import _slicedToArray from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
// import dynamic from 'next/dynamic';
import styled from 'styled-components';
import styles, { InstantPreviewLoadingBlock, SeparatorBlock, InputContainer, ExpandCollapseButton } from './InstantPreview.style';
import Image from '../../atoms/Image';
import { useRouter } from 'next/router';
import AppServiceControls from './AppServiceControls';
var InstantPreviewBlock = styled.section.withConfig({
  componentId: "sc-br6vf1-0"
})(["", ";"], styles);

// TODO: make it collapsible
var InstantPreview = function InstantPreview() {
  var _useState = useState({
      siteId: ''
    }),
    state = _useState[0],
    setState = _useState[1];
  var _useState2 = useState(true),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(false),
    isLoaded = _useState3[0],
    setIsLoaded = _useState3[1];
  var router = useRouter();
  var queryParameters = new URLSearchParams(window.location.search);
  var type = queryParameters.get("showIPcontrols");
  if (type === 'false') {
    return __jsx(React.Fragment, null);
  }
  var handleCollapse = function handleCollapse() {
    setIsOpen(function (prev) {
      return !prev;
    });
  };
  var handleInputChange = function handleInputChange(event) {
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;
    setState(function (prevProps) {
      return _objectSpread(_objectSpread({}, prevProps), {}, _defineProperty({}, name, value));
    });
  };
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    if (state !== null && state !== void 0 && state.siteId) {
      var _window, _window$location;
      setIsLoaded(true);
      setState(function (prevProps) {
        return _objectSpread({}, prevProps);
      });
      var url = ((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin) + '/:' + (state === null || state === void 0 ? void 0 : state.siteId);
      console.log('handleSubmit', url);
      window.location.href = url;
    }
  };
  var handleReset = function handleReset(event) {
    var _window2, _window2$location;
    event.preventDefault();
    setState(function (prevProps) {
      return _objectSpread({}, prevProps);
    });
    localStorage.removeItem('instantPreviewSiteId');
    localStorage.removeItem('instantPreviewEdit');
    var url = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.origin;
    // console.log('handleReset', url);
    window.location.href = url;
  };
  var handleRefresh = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var _window3, _window3$location;
      var url, axios;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              setIsLoaded(true);
              setState(function (prevProps) {
                return _objectSpread({}, prevProps);
              });
              url = "/api/revalidate/?url=".concat(encodeURIComponent((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$location = _window3.location) === null || _window3$location === void 0 ? void 0 : _window3$location.pathname));
              console.log("handleRefresh", url);
              _context.next = 7;
              return import('axios');
            case 7:
              axios = _context.sent["default"];
              axios({
                url: url,
                method: 'get'
              }).then(function (response) {
                var _window4;
                console.log('success', response === null || response === void 0 ? void 0 : response.data);
                if ((_window4 = window) !== null && _window4 !== void 0 && _window4.location) {
                  var _window5, _window5$location;
                  // response?.data
                  (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$location = _window5.location) === null || _window5$location === void 0 ? void 0 : _window5$location.reload();
                }
              })["catch"](function (response) {
                console.log('fail', response);
              });
            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function handleRefresh(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var handleEditPage = function handleEditPage(event) {
    event.preventDefault();
    var entryUrl = getEntryUrl();
    if (entryUrl) {
      window.open(entryUrl, '_blank');
    }
  };
  var handleEditSite = function handleEditSite(event) {
    event.preventDefault();
    var siteUrl = getSiteUrl();
    if (siteUrl) {
      window.open(siteUrl, '_blank');
    }
  };
  var getSiteId = function getSiteId() {
    var _localStorage, _localStorage2, _process, _process$env;
    var siteId = (_localStorage = localStorage) !== null && _localStorage !== void 0 && _localStorage.getItem('instantPreviewSiteId') ? parseInt((_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.getItem('instantPreviewSiteId')) : parseInt((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NEXT_PUBLIC_SITEID);
    return siteId;
  };
  var getEntryUrl = function getEntryUrl() {
    var _localStorage3, _localStorage4;
    var entryUrl = (_localStorage3 = localStorage) !== null && _localStorage3 !== void 0 && _localStorage3.getItem('instantPreviewEdit') ? (_localStorage4 = localStorage) === null || _localStorage4 === void 0 ? void 0 : _localStorage4.getItem('instantPreviewEdit') : null;
    return entryUrl;
  };
  var getSiteUrl = function getSiteUrl() {
    var _localStorage5, _localStorage6;
    var siteUrl = (_localStorage5 = localStorage) !== null && _localStorage5 !== void 0 && _localStorage5.getItem('instantPreviewWebsite') ? (_localStorage6 = localStorage) === null || _localStorage6 === void 0 ? void 0 : _localStorage6.getItem('instantPreviewWebsite') : null;
    return siteUrl;
  };
  useEffect(function () {
    setState({
      siteId: getSiteId()
    });
    // do it again in 2 seconds  
    setTimeout(function () {
      setState({
        siteId: getSiteId()
      });
    }, 2000);
    var handleClick = function handleClick(event) {
      var anchor = event.target;
      while (anchor && anchor.tagName !== 'A') {
        anchor = anchor.parentElement;
      }
      if (!anchor || anchor.tagName !== 'A') return;
      var href = anchor.getAttribute('href');
      var siteId = getSiteId();
      if (!href || href.startsWith('http') || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.includes(":".concat(siteId)) || href.includes(':')) {
        return;
      }
      var _href$split = href.split('#'),
        _href$split2 = _slicedToArray(_href$split, 2),
        pathWithQuery = _href$split2[0],
        hash = _href$split2[1];
      var _pathWithQuery$split = pathWithQuery.split('?'),
        _pathWithQuery$split2 = _slicedToArray(_pathWithQuery$split, 2),
        path = _pathWithQuery$split2[0],
        query = _pathWithQuery$split2[1];
      var newHref = path + ':' + siteId;
      if (query) {
        newHref += '?' + query;
      }
      if (hash) {
        newHref += '#' + hash;
      }
      event.preventDefault();
      window.location.href = newHref;
    };
    document.addEventListener('click', handleClick, true);
    return function () {
      return document.removeEventListener('click', handleClick, true);
    };
  }, []);
  return __jsx(InstantPreviewBlock, {
    className: "nva-instant-preview ".concat(isOpen ? 'is-opened' : 'is-collapsed')
  }, __jsx("form", {
    onSubmit: handleSubmit,
    className: "nva-instant-preview__form"
  }, __jsx("div", {
    className: "form-control"
  }, __jsx("div", {
    className: "nva-instant-preview__label-wrapper"
  }, __jsx("label", null, "Instant Preview"), __jsx(SeparatorBlock, null)), __jsx("div", {
    className: "nva-instant-preview__controls-wrapper"
  }, __jsx(InputContainer, null, __jsx("input", {
    className: "nva-instant-preview__input-site-id",
    type: "number",
    name: "siteId",
    placeholder: "Site ID",
    value: state.siteId,
    onChange: handleInputChange
  })), __jsx("button", {
    onClick: handleSubmit,
    type: "submit",
    title: "Apply the new Site ID",
    className: "nva-instant-preview__submit-site-id submit"
  }, __jsx(Image, {
    alt: "Apply the new Site ID",
    src: "/svg/eye.svg",
    width: 20,
    height: 20
  }), "View Site"), __jsx("button", {
    className: "nva-instant-preview__refresh-button",
    onClick: handleRefresh,
    title: "Refresh the page to see the new content"
  }, __jsx(Image, {
    alt: "Refresh the page to see the new content",
    src: "/svg/eye.svg",
    width: 20,
    height: 20
  }), "View Changes"), __jsx("button", {
    className: "nva-instant-preview__edit-button edit",
    onClick: handleEditPage,
    title: "Edit current entry page in Contentful"
  }, "Edit Page"), __jsx("button", {
    className: "nva-instant-preview__edit-button edit",
    onClick: handleEditSite,
    title: "Edit Website entry in Contentful"
  }, "Edit Site")), __jsx(ExpandCollapseButton, {
    className: "nva-instant-preview__expand-button",
    type: "button",
    onClick: handleCollapse,
    title: "Expand or collapse"
  }, __jsx(Image, {
    alt: "Expand or collapse",
    src: "/svg/".concat(isOpen ? 'arrow-right' : 'arrow-left', ".svg"),
    width: 25,
    height: 25
  }))), __jsx(AppServiceControls, {
    getSiteId: getSiteId
  })), isLoaded && __jsx(InstantPreviewLoadingBlock, null, __jsx("div", {
    className: "lds-dual-ring"
  })));
};
export default styled(InstantPreview).withConfig({
  componentId: "sc-br6vf1-1"
})(["", ";"], styles);